import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CHANNELS } from "@/lib/data";

const WHATNOT_IMG =
  "https://images.unsplash.com/photo-1673196649671-eb09066ad6c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function WhereWeSell() {
  return (
    <section
      id="sell"
      data-testid="where-we-sell"
      className="relative bg-[#050505] py-24 md:py-32"
    >
      <div className="w-full max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-14 md:mb-20">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-xs uppercase tracking-[0.3em] text-[#3FE1D1] font-medium"
          >
            Where & When We Sell
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="mt-4 font-display font-extrabold uppercase tracking-tighter text-white text-4xl md:text-6xl leading-[0.92]"
          >
            Three stages.<br />
            <span className="text-white/40">One team.</span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          {CHANNELS.map((c, i) => (
            <motion.a
              key={c.key}
              href={c.href}
              target="_blank"
              rel="noreferrer"
              data-testid={`channel-${c.key}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative overflow-hidden border p-8 md:p-10 min-h-[300px] flex flex-col justify-between transition-all duration-300 ${
                c.span
              } ${
                c.accent
                  ? "bg-[#3FE1D1] border-[#3FE1D1] text-[#050505]"
                  : "bg-[#0f0f10] border-[#262629] text-white hover:border-[#3FE1D1]/60"
              }`}
            >
              {c.key === "whatnot" && (
                <img
                  src={WHATNOT_IMG}
                  alt=""
                  className="absolute inset-0 w-full h-full object-cover opacity-15 mix-blend-luminosity"
                />
              )}
              {c.key === "ebay" && (
                <div className="absolute bottom-2 left-0 right-0 overflow-hidden opacity-[0.06] pointer-events-none">
                  <div className="marquee-track whitespace-nowrap flex">
                    {[0, 1].map((k) => (
                      <span key={k} className="font-impact text-[9rem] leading-none pr-8">
                        3,000+ ITEMS · BUY IT NOW · 3,000+ ITEMS · BUY IT NOW ·
                      </span>
                    ))}
                  </div>
                </div>
              )}

              <div className="relative z-10 flex items-center justify-between">
                <span
                  className={`text-[10px] uppercase tracking-[0.25em] font-semibold px-3 py-1.5 border ${
                    c.accent
                      ? "border-black/30 bg-black/10"
                      : "border-[#3FE1D1]/40 text-[#3FE1D1]"
                  }`}
                >
                  {c.status}
                </span>
                <ArrowUpRight
                  className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                  size={26}
                />
              </div>

              <div className="relative z-10">
                <h3 className="font-display font-extrabold uppercase tracking-tight text-3xl md:text-5xl leading-none">
                  {c.name}
                </h3>
                <p className={`mt-2 font-display text-lg ${c.accent ? "text-black/70" : "text-[#3FE1D1]"}`}>
                  {c.tagline}
                </p>
                <p className={`mt-4 max-w-md text-sm md:text-base leading-relaxed ${c.accent ? "text-black/70" : "text-white/55"}`}>
                  {c.copy}
                </p>
                <p className={`mt-5 text-xs uppercase tracking-[0.16em] font-semibold ${c.accent ? "text-black/80" : "text-white/70"}`}>
                  {c.meta} <span className="ml-2 underline underline-offset-4">{c.cta}</span>
                </p>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
